import { Button, ButtonGroup, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import React from 'react';

interface TeaserPageLenderActionButtonProps {
	onAddLender: () => void;
	onGetMatchedLenders: () => void;
	onSearchLender: () => void;
	onAddFromOtherDeal: () => void;
}

type TeaserPageActionItem = keyof typeof TeaserPageActionItemMap;
const TeaserPageActionItemMap = {
	AddLender: 'Add From Matching',
	GetMatchedLenders: 'Get Matched Lenders',
	SearchLender: 'Search For Lender',
	AddFromOtherDeal: 'Add From Other Deal',
};

export const TeaserPageLenderActionButton: React.FC<TeaserPageLenderActionButtonProps> = ({
	onAddLender,
	onGetMatchedLenders,
	onSearchLender,
	onAddFromOtherDeal,
}) => {
	const [open, setOpen] = React.useState(false);
	const anchorRef = React.useRef<HTMLDivElement>(null);

	const handleToggle = () => {
		setOpen(prevOpen => !prevOpen);
	};

	const handleClick = (action: TeaserPageActionItem) => {
		switch (action) {
			case 'AddLender':
				onAddLender();
				break;
			case 'GetMatchedLenders':
				onGetMatchedLenders();
				break;
			case 'SearchLender':
				onSearchLender();
				break;
			case 'AddFromOtherDeal':
				onAddFromOtherDeal();
				break;
		}
	};

	const handleClose = (event: Event) => {
		if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
			return;
		}
		setOpen(false);
	};

	const handleMenuItemClick = (
		event: React.MouseEvent<HTMLLIElement, MouseEvent>,
		actionItem: TeaserPageActionItem
	) => {
		setOpen(false);
		handleClick(actionItem);
	};

	return (
		<>
			<ButtonGroup sx={{ marginRight: 3 }} variant="contained" ref={anchorRef} aria-label="split button">
				<Button onClick={handleToggle}>Add Lenders</Button>
				<Button
					size="small"
					aria-controls={open ? 'split-button-menu' : undefined}
					aria-expanded={open ? 'true' : undefined}
					aria-label="select merge strategy"
					aria-haspopup="menu"
					onClick={handleToggle}
				>
					<ArrowDropDownIcon />
				</Button>
			</ButtonGroup>
			<Popper
				open={open}
				style={{ zIndex: 1000, margin: 0 }}
				anchorEl={anchorRef.current}
				role={undefined}
				transition
				disablePortal
			>
				{({ TransitionProps, placement }) => (
					<Grow
						{...TransitionProps}
						style={{
							transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
						}}
					>
						<Paper>
							<ClickAwayListener onClickAway={handleClose}>
								<MenuList id="split-button-menu" autoFocusItem>
									<MenuItem onClick={event => handleMenuItemClick(event, 'AddLender')}>
										{TeaserPageActionItemMap['AddLender']}
									</MenuItem>
									<MenuItem onClick={event => handleMenuItemClick(event, 'GetMatchedLenders')}>
										{TeaserPageActionItemMap['GetMatchedLenders']}
									</MenuItem>
									<MenuItem onClick={event => handleMenuItemClick(event, 'SearchLender')}>
										{TeaserPageActionItemMap['SearchLender']}
									</MenuItem>
									<MenuItem onClick={event => handleMenuItemClick(event, 'AddFromOtherDeal')}>
										{TeaserPageActionItemMap['AddFromOtherDeal']}
									</MenuItem>
								</MenuList>
							</ClickAwayListener>
						</Paper>
					</Grow>
				)}
			</Popper>
		</>
	);
};
